module.exports = __webpack_public_path__ + "img/03-05-jm-fw-1.4cd691b7.png";